<template>
  <!-- <SpinnerCom v-if="isLoading" class="text-red-500 flex justify-center items-center min-h-svh" />
  <div v-else></div> -->
    <RouterView />
  
</template>
<script>
  import { defineComponent } from 'vue'
  import 'handsontable/dist/handsontable.full.css'

  // import SpinnerCom from '@/components/ui/SpinnerCom.vue'

  export default defineComponent({
    // components: { SpinnerCom },
    data() {
      return {}
    },
  })
</script>
